import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { Select } from '../../../shared/select.component'
import { ItemPreferenceBase } from '../../../../services/json-schemas/base/item_preference'

export default function CastingPreferencesPickerComponent ({ store, data: { offeredService: { preferences }, selectedItemPreferenceIds } }: StoreProps) {
  const removeThenAdd = React.useCallback((removeId: ItemPreferenceBase['id'], addId: ItemPreferenceBase['id']) => {
    const newSelection = selectedItemPreferenceIds.filter(_ => _ !== removeId)
    if (addId) newSelection.push(addId)
    store.set({ selectedItemPreferenceIds: newSelection })
  }, [selectedItemPreferenceIds, store])

  return <>
    { preferences.map((preference, index) => {
      switch (preference.preference_type) {
        case 'checkbox': {
          const firstItem = preference.item_preferences[0]

          return <div key={ index } className="inputCheckbox form-group">
            <input
              type="checkbox"
              id={ `preference-${firstItem.id}` }
              onChange={ evt => evt.target.checked ? removeThenAdd(null, firstItem.id) : removeThenAdd(firstItem.id, null) }
              checked={ selectedItemPreferenceIds.includes(firstItem.id) } />
            <label htmlFor={ `preference-${firstItem.id}` }>{ preference.name }</label>
          </div>
        }

        case 'dropdown': {
          const currentlySelected = preference.item_preferences.find(_ => selectedItemPreferenceIds.includes(_.id))

          return <div key={ index } className="form-group">
            <label>{ preference.name }</label>
            <Select
              value={ currentlySelected }
              options={ preference.item_preferences }
              getOptionLabel={ val => val.name }
              getOptionValue={ val => val.id.toString() }
              placeholder={ preference.name }
              onChange={ val => removeThenAdd(currentlySelected?.id, val?.id) }
              isClearable
              isSearchable={ false } />
          </div>
        }
      }
    }) }
  </>
}
